<template>
    <div>
        <b-table
            :items="items"
            :fields="fields"
            :busy="loading"
            primary-key="id"
            table-class="table-va-middle"
            class="shadow-sm"
            empty-text="Nenhum usuário cadastrado."
            :responsive="true"
            :per-page="perPage"
            :current-page="currentPage"
            fixed
            show-empty
            striped
            bordered
        >
            <template v-slot:table-busy>
                <div class="text-center my-3">
                    <b-spinner class="align-middle mr-1" />
                    <span class="align-middle"> Carregando usuários... </span>
                </div>
            </template>
            <template #row-details="row">
                <users-detail :user="row.item" />
            </template>
            <template v-slot:cell(groups)="{ item }">
                {{ humanize(item) }}
            </template>
            <template v-slot:cell(is_active)="{ item }">
                <i
                    v-b-tooltip.hover.left="
                        item.is_active
                            ? 'Acesso liberado.'
                            : 'Acesso bloqueado.'
                    "
                    :class="`far ${
                        item.is_active
                            ? 'fa-check-circle text-success'
                            : `fa-times-circle text-danger`
                    }`"
                />
            </template>
            <template v-slot:cell(id)="{ item, toggleDetails, detailsShowing }">
                <b-button
                    v-b-tooltip.hover.left="
                        detailsShowing ? 'Esconder detalhes' : 'Ver detalhes'
                    "
                    size="sm"
                    variant="secondary"
                    class="mb-2 mb-lg-0"
                    @click="toggleDetails"
                    ><i class="fas fa-fw fa-eye"></i
                ></b-button>
                <b-button
                    v-b-tooltip.hover.left="'Editar usuário'"
                    size="sm"
                    variant="primary"
                    class="ml-lg-4 ml-0 mb-2 mb-lg-0"
                    @click="edit(item)"
                    ><i class="fas fa-fw fa-pencil-alt"></i
                ></b-button>
                <b-button
                    v-b-tooltip.hover.window.right="'Apagar usuário'"
                    size="sm"
                    variant="danger"
                    class="ml-lg-4 ml-0"
                    @click="remove(item)"
                    ><i class="fas fa-fw fa-trash-alt"></i
                ></b-button>
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="users.length"
            :per-page="perPage"
            first-text="Primeira página"
            last-text="Última página"
            align="center"
            :disabled="loading"
        />
    </div>
</template>

<script>
import humanizeList from "@/utils/humanizeList";
import UsersDetail from "./UsersDetail";
export default {
    name: "UsersTable",
    components: {
        UsersDetail
    },
    props: {
        loading: {
            type: Boolean
        },
        users: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            currentPage: 1,
            perPage: 5
        };
    },
    computed: {
        items() {
            return this.users.map(item => ({ ...item }));
        }
    },
    created() {
        this.fields = [
            {
                label: "Usuário",
                key: "username",
                sortable: true,
                thStyle: {
                    width: "130px"
                }
            },
            {
                label: "Nome",
                key: "first_name",
                sortable: true,
                formatter(value, key, item) {
                    return `${item.first_name} ${item.last_name}`;
                }
            },
            {
                label: "Permissão de acesso",
                key: "groups",
                sortable: true,
                thStyle: {
                    width: "370px"
                }
            },
            {
                label: "Ativo",
                key: "is_active",
                tdClass: "text-center",
                thStyle: {
                    width: "80px"
                }
            },
            {
                label: "Gerenciar",
                key: "id",
                tdClass: "text-center",
                thStyle: {
                    width: "180px"
                }
            }
        ];
    },
    methods: {
        humanize(item) {
            if (item.is_superuser) {
                return "Administrador";
            }
            return humanizeList(item.groups);
        },
        edit(user) {
            this.$emit("edit", user);
        },
        remove(user) {
            this.$emit("remove", user);
        }
    }
};
</script>
